export default __webpack_public_path__ + "static/media/SpoqaHanSansNeo-Regular.b935041c.ttf";